import { Typography } from "antd";
import { Link } from "react-router";

export function Brand() {
  return (
    <Link to="/" className="brand">
      <img src="./lmcc-logo.png" alt="LMCC" className="brand-logo" />
      <Typography.Text strong className="brand-title">LMCC 认证管理</Typography.Text>
    </Link>
  );
}
